import data from '../../data/data';
import Carousel from '../utils/Carousel';
import LazyImage from '../utils/LazyImage';
import { track, Events } from '../../lib/analytics';

function CertificationSection() {
	const { certifications } = data;

	const items = certifications.map((cert, i) => (
		<div key={i} className="custem-carousel-item rounded bg-dark wow fadeIn">
			<a href={`#small-dialog-cert-${i}`} className="work-content" onClick={() => track(Events.OPEN_CERT, { name: cert.name })}>
				<div className="thumb cert-thumb">
					<span className="category">{cert.category}</span>
					<LazyImage
						src={cert.thumb}
						alt={cert.name}
						style={{
							width: 'auto',
							height: '100%',
							maxWidth: '100%',
							objectFit: 'contain',
						}}
					/>
				</div>
				<div className="details">
					<h4 className="my-0 title">
						{cert.name}
					</h4>
					<ul className="list-inline meta mb-0 mt-2">
						<li className="list-inline-item">{cert.start}</li>
						<li className="list-inline-item">{cert.end}</li>
					</ul>
				</div>
			</a>
		</div>
	));

	return (
		<div className="row blog-wrapper">
			{certifications.map((cert, i) => (
				<div
					key={i}
					id={`small-dialog-cert-${i}`}
					className="white-popup zoom-anim-dialog mfp-hide"
				>
					<LazyImage
						src={cert.image}
						alt={cert.name}
					/>
					<br />
					<br />
					<a
						href={cert.url}
						className="btn btn-default"
						target="_blank"
						rel="noreferrer"
						onClick={() => track(Events.VIEW_CERT, { name: cert.name })}
					>
						Show Credential
					</a>
				</div>
			))}

			<Carousel items={items} />
		</div>
	);
}

export default CertificationSection;
